<template lang="pug">
div
  .form-group
    label.text.optional.control-label.client-invoice-notes(for="client_invoice_notes") Notes (Shown on invoices)
    ValidationProvider(name="useOrganizationNotes")
      #client_use_organization_notes
        label.toggle-switch-wrapper
          input(
            v-model="useCustomNotes"
            type="checkbox"
          )
          .toggle-switch
          span.toggle-switch-label Custom for this client
    ValidationProvider(name="invoiceNotes")
      #client_invoice_notes
        textarea.form-control(
          v-model="invoiceNotes"
          placeholder="Enter notes to client"
          :disabled="!useCustomNotes"
        )
  .row
    .col-sm-6.col-lg-6
      .form-group
        .label-with-tooltip.client-net-terms
          label.string.optional.control-label Net terms
          i.hi.hi-info.text-lighter.a-tooltip.ml-5(
            v-tooltip="{ placement: 'right' }"
            title="Amount of days the invoice must be paid once created"
          )
        ValidationProvider(name="useOrganizationNotes")
          #client_use_organization_net_terms
            label.toggle-switch-wrapper
              input.boolean.optional(
                v-model="useCustomNetTerms"
                type="checkbox"
              )
              .toggle-switch
              span.toggle-switch-label Custom for this client
        ValidationProvider(
          v-slot="{ errors }"
          :rules="'required|numeric|max_value:10000'"
          name="net_terms"
        )
          #client_net_terms(:class="{ 'has-error': errors[0] }")
            .input-group
              input.form-control(
                v-model="netTerms"
                :disabled="!useCustomNetTerms"
              )
              span.input-group-addon days
            AppDialogError(:errors="errors")
    .col-sm-6.col-lg-6
      .form-group
        .label-with-tooltip.client-tax-rate
          label.string.optional.control-label Tax Rate
          i.hi.hi-info.text-lighter.a-tooltip.ml-5(
            v-tooltip="{ placement: 'right' }"
            title="The percentage of tax you want applied to the invoice total"
          )
        ValidationProvider(name="useCustomTaxRate")
          #client_use_organization_tax_rate
            label.toggle-switch-wrapper
              input.boolean.optional(
                v-model="useCustomTaxRate"
                type="checkbox"
              )
              .toggle-switch
              span.toggle-switch-label Custom for this client
        ValidationProvider(
          v-slot="{ errors }"
          :rules="'greaterThanZero|required'"
          name="taxRate"
          :disabled="!useCustomTaxRate"
        )
          #client_tax_rate(:class="{ 'has-error': errors[0] }")
            .input-group
              input.form-control(
                v-model="taxRate"
                :disabled="!useCustomTaxRate"
                placeholder="Ex. 7"
                maxlength="6"
                min="0"
                max="100"
                step="0.01"
              )
              span.input-group-addon %
            AppDialogError(:errors="errors")
  AutoInvoicingSettingsForm(
    client-mode
    :new-form="isNewForm"
    :start-week-on="startWeekOn"
  )
</template>

<script>
import { mapActions, mapState } from 'vuex';

import AutoInvoicingSettingsForm from '../invoices_settings/AutoInvoicingSettingsForm.vue';

export default {
  name: 'ClientDialogTabInvoicing',
  components: {
    AutoInvoicingSettingsForm,
  },
  computed: {
    ...mapState(['organization', 'client', 'errors', 'isNewForm']),
    useCustomNotes: {
      get() {
        return !this.client.use_organization_notes;
      },
      set(value) {
        this.updateField({ path: 'use_organization_notes', value: !value });
      },
    },
    invoiceNotes: {
      get() {
        return !this.client.use_organization_notes ? this.client.invoice_notes : this.organization.invoice_notes;
      },
      set(value) {
        this.updateField({ path: 'invoice_notes', value });
      },
    },
    useCustomNetTerms: {
      get() {
        return !this.client.use_organization_net_terms;
      },
      set(value) {
        this.updateField({ path: 'use_organization_net_terms', value: !value });
      },
    },
    netTerms: {
      get() {
        return !this.client.use_organization_net_terms ? this.client.net_terms : this.organization.net_terms;
      },
      set(value) {
        this.updateField({ path: 'net_terms', value });
      },
    },
    useCustomTaxRate: {
      get() {
        return !this.client.use_organization_tax_rate;
      },
      set(value) {
        this.updateField({ path: 'use_organization_tax_rate', value: !value });
      },
    },
    taxRate: {
      get() {
        return !this.client.use_organization_tax_rate ? this.client.tax_1 : this.organization.tax_1;
      },
      set(value) {
        this.updateField({ path: 'tax_1', value });
      },
    },
    startWeekOn() {
      return this.organization.start_week_on;
    },
  },
  methods: {
    ...mapActions(['updateField']),
  },
};
</script>
